import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0081FF',
        secondary: '#FFFFFF',
        error: '#EF0606',
        success: '#4c674c',
        info: '#000000',
        accent: '#FFFF00',
        warning: '#FFC107',
        header: '#FFFFFF',
        widget: '#FCFDFD',
        widgetsList: '#151C2E',
        elements: '#358ED7',
        headerText: '#888a87',
        widgetText: '#888a87',
        widgetsListIcons: '#ebebeb',
        elementsText: '#ffffff',
      },
      dark: {
        primary: '#0081FF',
        secondary: '#FFFFFF',
        error: '#EF0606',
        success: '#4c674c',
        info: '#000000',
        accent: '#FFFF00',
        warning: '#FFC107',
        header: '#FFFFFF',
        widget: '#FCFDFD',
        widgetsList: '#151C2E',
        elements: '#358ED7',
        headerText: '#888a87',
        widgetText: '#888a87',
        widgetsListIcons: '#ebebeb',
        elementsText: '#ffffff',
      },
    },
  },
})
